import type { ValueOf } from 'type-fest';

export const PART_PANEL_STATES = {
  CAD: 'CAD',
  FILES: 'FILES',
  QUOTES_AND_ORDERS: 'QUOTES_AND_ORDERS',
  BOM: 'BOM',
} as const;

export type PartPanelStateValues = ValueOf<typeof PART_PANEL_STATES>;

export const DESKTOP_APPS_PANEL_STATES = {
  PART_SETUP_TOOL: 'PART_SETUP_TOOL',
  MSC_CHAT: 'MSC_CHAT',
  ONLINE_METALS_MATERIAL_WIDGET: 'ONLINE_METALS_MATERIAL_WIDGET',
  PENN_AVAILABILITY_WIDGET: 'PENN_AVAILABILITY_WIDGET',
  PENN_CHAT: 'PENN_CHAT',
  PENN_MENU_WIDGET: 'PENN_MENU_WIDGET',
  SIMILAR_PARTS: 'SIMILAR_PARTS',
  VIEWER_CHAT: 'VIEWER_CHAT',
  FUSION: 'FUSION',
  REQS_REVIEW: 'REQS_REVIEW',
} as const;

// For space constraints, mobile has to treat the part controls as an app
export const MOBILE_ONLY_PANEL_STATES = {
  PART_CONTROLS: 'PART_CONTROLS',
} as const;

export type MobileOnlyPanelStateValues = ValueOf<
  typeof MOBILE_ONLY_PANEL_STATES
>;

export const APPS_PANEL_STATES = {
  ...DESKTOP_APPS_PANEL_STATES,
  ...MOBILE_ONLY_PANEL_STATES,
} as const;

export type AppsPanelStateValues = ValueOf<typeof APPS_PANEL_STATES>;

export const SIMILAR_PARTS_TAB = {
  FACETED_SEARCH: 'FACETED_SEARCH',
  PARAMETRIC_SEARCH: 'PARAMETRIC_SEARCH',
} as const;

export type SimilarPartsTabValues = ValueOf<typeof SIMILAR_PARTS_TAB>;

export const ERROR_CODES = {
  MFA_OR_SSO_REQUIRED: 'MFA_OR_SSO_REQUIRED',
} as const;

export type ErrorCodesValues = ValueOf<typeof ERROR_CODES>;
